// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --site-ink: #283036;
  --site-muted: #66747c;
  --site-blue: #416f9d;
  --site-border: #dce5eb;
  --site-soft: #edf4f8;
}
* {
  box-sizing: border-box;
}
html {
  scroll-behavior: smooth;
  scroll-padding-top: 140px;
}
body {
  margin: 0;
  color: var(--site-ink);
  background: #f5f8fa;
  font-family: Figtree, Arial, sans-serif;
  line-height: 1.6;
  letter-spacing: 0;
}
button,
input,
textarea,
select {
  font: inherit;
  letter-spacing: 0;
}
button,
a,
input,
textarea,
select {
  -webkit-tap-highlight-color: transparent;
}
button {
  cursor: pointer;
}
button:disabled {
  cursor: default;
  opacity: 0.6;
}
a {
  color: var(--site-blue);
}
:focus-visible {
  outline: 3px solid #6c99c2;
  outline-offset: 3px;
}
.site-shell {
  width: min(1180px, calc(100% - 48px));
  margin-inline: auto;
}
.site-header {
  position: sticky;
  top: 0;
  z-index: 20;
  background: #fff;
  border-bottom: 1px solid var(--site-border);
}
.site-header-inner {
  min-height: 78px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
}
.site-brand {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
  color: var(--site-ink);
  font-size: 22px;
  line-height: 1.2;
  white-space: nowrap;
}
.site-brand img {
  width: 42px;
  height: 42px;
  object-fit: contain;
  border-radius: 50%;
}
.site-header nav {
  display: flex;
  gap: 26px;
}
.site-header nav a {
  color: #56646b;
  text-decoration: none;
  font-size: 15px;
}
.site-button,
.site-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 42px;
  padding: 9px 17px;
  border: 1px solid transparent;
  border-radius: 6px;
  background: var(--site-blue);
  color: #fff;
  text-decoration: none;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.4;
}
.site-button svg,
.site-icon svg {
  flex-shrink: 0;
}
.site-button.secondary {
  background: #fff;
  color: var(--site-blue);
  border-color: #cbdbe7;
}
.site-button.quiet {
  background: transparent;
  color: var(--site-muted);
  border-color: var(--site-border);
}
.site-button:hover:not(:disabled) {
  filter: brightness(0.96);
}
.site-icon {
  width: 40px;
  height: 40px;
  min-height: 40px;
  padding: 0;
  border-color: var(--site-border);
  background: #fff;
  color: #596e7b;
}
.site-icon[aria-pressed='true'] {
  background: var(--site-soft);
  color: var(--site-blue);
  border-color: #b4cbdd;
}
.site-footer {
  margin-top: 64px;
  border-top: 1px solid var(--site-border);
  background: #fff;
  color: var(--site-muted);
  font-size: 14px;
}
.site-footer .site-shell {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  min-height: 85px;
  padding-block: 20px;
}
.site-footer a {
  text-decoration: none;
}
.site-status {
  padding: 30px 0;
  color: var(--site-muted);
}
.site-notice {
  padding: 12px 16px;
  margin-block: 16px;
  background: #e9f3ed;
  color: #345f49;
  border-left: 3px solid #6d927d;
  overflow-wrap: anywhere;
}
.site-notice.error {
  background: #fff1ef;
  color: #934a43;
  border-color: #ce8b80;
}
.profile-avatar {
  display: block;
  width: 150px;
  height: 150px;
  border-radius: 50%;
  overflow: hidden;
  background: #e7eef2;
}
.profile-avatar img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.profile-initials {
  display: grid;
  place-items: center;
  font-size: 40px;
  color: #638879;
  background: #e8f0eb;
}
.site-directory {
  padding-top: 55px;
  min-height: 65vh;
}
.site-directory h1 {
  font-size: 38px;
  line-height: 1.2;
  margin: 0 0 12px;
  font-weight: 650;
}
.site-directory-intro {
  margin: 0 0 35px;
  color: var(--site-muted);
}
.profile-directory-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 24px;
}
.profile-directory-card {
  padding: 30px;
  border: 1px solid var(--site-border);
  border-radius: 8px;
  background: #fff;
  color: inherit;
  text-decoration: none;
}
.profile-directory-card .profile-avatar {
  width: 100px;
  height: 100px;
  margin-bottom: 22px;
}
.profile-directory-card h2 {
  margin: 0 0 6px;
  font-size: 25px;
  overflow-wrap: anywhere;
}
.profile-directory-card p {
  color: var(--site-muted);
  margin: 0;
}
.profile-directory-card:hover {
  border-color: #adc8dc;
}
@media (max-width: 900px) {
  .site-header nav {
    display: none;
  }
  .profile-directory-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 600px) {
  .site-shell {
    width: calc(100% - 32px);
  }
  .site-header-inner {
    min-height: 68px;
    gap: 12px;
  }
  .site-brand {
    font-size: 19px;
    gap: 7px;
  }
  .site-brand img {
    width: 32px;
    height: 32px;
  }
  .site-header .site-button {
    width: 40px;
    height: 40px;
    min-height: 40px;
    padding: 0;
  }
  .site-header .site-button span {
    display: none;
  }
  .site-directory h1 {
    font-size: 32px;
  }
  .profile-directory-grid {
    grid-template-columns: minmax(0, 1fr);
  }
}
`, "",{"version":3,"sources":["webpack://./src/SiteLayout.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;EACpB,sBAAsB;EACtB,oBAAoB;AACtB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,uBAAuB;EACvB,yBAAyB;AAC3B;AACA;EACE,SAAS;EACT,sBAAsB;EACtB,mBAAmB;EACnB,uCAAuC;EACvC,gBAAgB;EAChB,iBAAiB;AACnB;AACA;;;;EAIE,aAAa;EACb,iBAAiB;AACnB;AACA;;;;;EAKE,wCAAwC;AAC1C;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,YAAY;AACd;AACA;EACE,uBAAuB;AACzB;AACA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;EACE,qCAAqC;EACrC,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,gBAAgB;EAChB,2CAA2C;AAC7C;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,qBAAqB;EACrB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;AACjB;AACA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;EAClB,4BAA4B;EAC5B,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;AACvB;AACA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,gCAAgC;AAClC;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,gCAAgC;EAChC,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,4BAA4B;EAC5B,uBAAuB;EACvB,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,wCAAwC;EACxC,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;AACjB;AACA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,8BAA8B;EAC9B,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;AACA;EACE,aAAa;EACb,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,wBAAwB;EACxB,SAAS;AACX;AACA;EACE,qBAAqB;AACvB;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,gDAAgD;EAClD;AACF;AACA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,gBAAgB;IAChB,SAAS;EACX;EACA;IACE,eAAe;IACf,QAAQ;EACV;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,UAAU;EACZ;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,qCAAqC;EACvC;AACF","sourcesContent":[":root {\n  --site-ink: #283036;\n  --site-muted: #66747c;\n  --site-blue: #416f9d;\n  --site-border: #dce5eb;\n  --site-soft: #edf4f8;\n}\n* {\n  box-sizing: border-box;\n}\nhtml {\n  scroll-behavior: smooth;\n  scroll-padding-top: 140px;\n}\nbody {\n  margin: 0;\n  color: var(--site-ink);\n  background: #f5f8fa;\n  font-family: Figtree, Arial, sans-serif;\n  line-height: 1.6;\n  letter-spacing: 0;\n}\nbutton,\ninput,\ntextarea,\nselect {\n  font: inherit;\n  letter-spacing: 0;\n}\nbutton,\na,\ninput,\ntextarea,\nselect {\n  -webkit-tap-highlight-color: transparent;\n}\nbutton {\n  cursor: pointer;\n}\nbutton:disabled {\n  cursor: default;\n  opacity: 0.6;\n}\na {\n  color: var(--site-blue);\n}\n:focus-visible {\n  outline: 3px solid #6c99c2;\n  outline-offset: 3px;\n}\n.site-shell {\n  width: min(1180px, calc(100% - 48px));\n  margin-inline: auto;\n}\n.site-header {\n  position: sticky;\n  top: 0;\n  z-index: 20;\n  background: #fff;\n  border-bottom: 1px solid var(--site-border);\n}\n.site-header-inner {\n  min-height: 78px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 20px;\n}\n.site-brand {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  text-decoration: none;\n  color: var(--site-ink);\n  font-size: 22px;\n  line-height: 1.2;\n  white-space: nowrap;\n}\n.site-brand img {\n  width: 42px;\n  height: 42px;\n  object-fit: contain;\n  border-radius: 50%;\n}\n.site-header nav {\n  display: flex;\n  gap: 26px;\n}\n.site-header nav a {\n  color: #56646b;\n  text-decoration: none;\n  font-size: 15px;\n}\n.site-button,\n.site-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  min-height: 42px;\n  padding: 9px 17px;\n  border: 1px solid transparent;\n  border-radius: 6px;\n  background: var(--site-blue);\n  color: #fff;\n  text-decoration: none;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.4;\n}\n.site-button svg,\n.site-icon svg {\n  flex-shrink: 0;\n}\n.site-button.secondary {\n  background: #fff;\n  color: var(--site-blue);\n  border-color: #cbdbe7;\n}\n.site-button.quiet {\n  background: transparent;\n  color: var(--site-muted);\n  border-color: var(--site-border);\n}\n.site-button:hover:not(:disabled) {\n  filter: brightness(0.96);\n}\n.site-icon {\n  width: 40px;\n  height: 40px;\n  min-height: 40px;\n  padding: 0;\n  border-color: var(--site-border);\n  background: #fff;\n  color: #596e7b;\n}\n.site-icon[aria-pressed='true'] {\n  background: var(--site-soft);\n  color: var(--site-blue);\n  border-color: #b4cbdd;\n}\n.site-footer {\n  margin-top: 64px;\n  border-top: 1px solid var(--site-border);\n  background: #fff;\n  color: var(--site-muted);\n  font-size: 14px;\n}\n.site-footer .site-shell {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  align-items: center;\n  gap: 20px;\n  min-height: 85px;\n  padding-block: 20px;\n}\n.site-footer a {\n  text-decoration: none;\n}\n.site-status {\n  padding: 30px 0;\n  color: var(--site-muted);\n}\n.site-notice {\n  padding: 12px 16px;\n  margin-block: 16px;\n  background: #e9f3ed;\n  color: #345f49;\n  border-left: 3px solid #6d927d;\n  overflow-wrap: anywhere;\n}\n.site-notice.error {\n  background: #fff1ef;\n  color: #934a43;\n  border-color: #ce8b80;\n}\n.profile-avatar {\n  display: block;\n  width: 150px;\n  height: 150px;\n  border-radius: 50%;\n  overflow: hidden;\n  background: #e7eef2;\n}\n.profile-avatar img {\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n.profile-initials {\n  display: grid;\n  place-items: center;\n  font-size: 40px;\n  color: #638879;\n  background: #e8f0eb;\n}\n.site-directory {\n  padding-top: 55px;\n  min-height: 65vh;\n}\n.site-directory h1 {\n  font-size: 38px;\n  line-height: 1.2;\n  margin: 0 0 12px;\n  font-weight: 650;\n}\n.site-directory-intro {\n  margin: 0 0 35px;\n  color: var(--site-muted);\n}\n.profile-directory-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 24px;\n}\n.profile-directory-card {\n  padding: 30px;\n  border: 1px solid var(--site-border);\n  border-radius: 8px;\n  background: #fff;\n  color: inherit;\n  text-decoration: none;\n}\n.profile-directory-card .profile-avatar {\n  width: 100px;\n  height: 100px;\n  margin-bottom: 22px;\n}\n.profile-directory-card h2 {\n  margin: 0 0 6px;\n  font-size: 25px;\n  overflow-wrap: anywhere;\n}\n.profile-directory-card p {\n  color: var(--site-muted);\n  margin: 0;\n}\n.profile-directory-card:hover {\n  border-color: #adc8dc;\n}\n@media (max-width: 900px) {\n  .site-header nav {\n    display: none;\n  }\n  .profile-directory-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n@media (max-width: 600px) {\n  .site-shell {\n    width: calc(100% - 32px);\n  }\n  .site-header-inner {\n    min-height: 68px;\n    gap: 12px;\n  }\n  .site-brand {\n    font-size: 19px;\n    gap: 7px;\n  }\n  .site-brand img {\n    width: 32px;\n    height: 32px;\n  }\n  .site-header .site-button {\n    width: 40px;\n    height: 40px;\n    min-height: 40px;\n    padding: 0;\n  }\n  .site-header .site-button span {\n    display: none;\n  }\n  .site-directory h1 {\n    font-size: 32px;\n  }\n  .profile-directory-grid {\n    grid-template-columns: minmax(0, 1fr);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
